/**
 * Black in Drupal — theme behaviors.
 */
(function (Drupal, once) {
  'use strict';

  // Mobile navigation drawer.
  Drupal.behaviors.bidDrawer = {
    attach: function (context) {
      once('bid-drawer', '[data-bid-drawer-open]', context).forEach(function (btn) {
        var drawer = document.querySelector('.bid-drawer');
        var backdrop = document.querySelector('.bid-backdrop');
        if (!drawer || !backdrop) return;
        var toggle = function (open) {
          drawer.classList.toggle('open', open);
          backdrop.classList.toggle('open', open);
          document.body.style.overflow = open ? 'hidden' : '';
        };
        btn.addEventListener('click', function () { toggle(true); });
        backdrop.addEventListener('click', function () { toggle(false); });
        drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { toggle(false); }); });
      });
    }
  };

  // Community spotlight: scroll the track one card via the arrows.
  Drupal.behaviors.bidSpotlight = {
    attach: function (context) {
      once('bid-spotlight', '.bid-spotlight', context).forEach(function (wrap) {
        var track = wrap.querySelector('.bid-spotlight__track');
        if (!track) return;
        var step = function () {
          var card = track.querySelector('.bid-spotlight__card');
          return card ? card.offsetWidth + 24 : track.clientWidth * 0.8;
        };
        var prev = wrap.querySelector('[data-spot="prev"]');
        var next = wrap.querySelector('[data-spot="next"]');
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
    }
  };

  // Events feed paragraph: horizontal slider (2–3 cards visible).
  Drupal.behaviors.bidEventsFeed = {
    attach: function (context) {
      once('bid-events-feed', '[data-bid-events-feed]', context).forEach(function (wrap) {
        var track = wrap.querySelector('.bid-events-feed__track');
        if (!track) return;
        var step = function () {
          var slide = track.querySelector('.bid-events-feed__slide');
          return slide ? slide.offsetWidth + 24 : track.clientWidth * 0.85;
        };
        var prev = wrap.querySelector('[data-feed="prev"]');
        var next = wrap.querySelector('[data-feed="next"]');
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
    }
  };

  // Member directory: clone modal to <body> so overflow/transform parents cannot trap it.
  Drupal.behaviors.bidMemberModal = {
    attach: function (context) {
      once('bid-member-modal', '[data-bid-member-open]', context).forEach(function (btn) {
        var id = btn.getAttribute('data-bid-member-open');
        var tpl = id ? document.getElementById(id + '-tpl') : null;
        if (!tpl) return;

        var modal = null;
        var close = function () {
          if (!modal) return;
          modal.hidden = true;
          document.body.classList.remove('bid-modal-open');
          btn.focus();
        };
        var open = function () {
          if (!modal) {
            modal = tpl.content.firstElementChild.cloneNode(true);
            document.body.appendChild(modal);
            modal.querySelectorAll('[data-bid-member-close]').forEach(function (el) {
              el.addEventListener('click', close);
            });
            modal.addEventListener('keydown', function (e) {
              if (e.key === 'Escape') close();
            });
          }
          modal.hidden = false;
          document.body.classList.add('bid-modal-open');
          var closer = modal.querySelector('.bid-member-modal__close');
          if (closer) closer.focus();
        };

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          open();
        });
      });
    }
  };

  // FAQ: only one details panel open at a time.
  Drupal.behaviors.bidFaqAccordion = {
    attach: function (context) {
      once('bid-faq-accordion', 'details.bid-faq__item', context).forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) {
            return;
          }
          var faq = item.closest('.bid-faq');
          if (!faq) {
            return;
          }
          faq.querySelectorAll('details.bid-faq__item[open]').forEach(function (other) {
            if (other !== item) {
              other.open = false;
            }
          });
        });
      });
    }
  };

  // Gallery album lightbox with next/prev.
  Drupal.behaviors.bidGalleryLightbox = {
    attach: function (context) {
      once('bid-gallery-lightbox', '.bid-gallery-album__grid', context).forEach(function (grid) {
        var imgs = Array.prototype.slice.call(grid.querySelectorAll('img'));
        if (!imgs.length) return;

        var lb = document.createElement('div');
        lb.className = 'bid-lightbox';
        lb.hidden = true;
        lb.innerHTML = '<button type="button" class="bid-lightbox__close" aria-label="Close">&times;</button>' +
          '<button type="button" class="bid-lightbox__nav bid-lightbox__nav--prev" aria-label="Previous">&larr;</button>' +
          '<img class="bid-lightbox__img" alt="" />' +
          '<button type="button" class="bid-lightbox__nav bid-lightbox__nav--next" aria-label="Next">&rarr;</button>' +
          '<div class="bid-lightbox__count"></div>';
        document.body.appendChild(lb);

        var imgEl = lb.querySelector('.bid-lightbox__img');
        var countEl = lb.querySelector('.bid-lightbox__count');
        var index = 0;

        var show = function (i) {
          index = (i + imgs.length) % imgs.length;
          imgEl.src = imgs[index].currentSrc || imgs[index].src;
          imgEl.alt = imgs[index].alt || '';
          countEl.textContent = (index + 1) + ' / ' + imgs.length;
          lb.hidden = false;
          document.body.classList.add('bid-modal-open');
        };
        var hide = function () {
          lb.hidden = true;
          document.body.classList.remove('bid-modal-open');
        };

        imgs.forEach(function (img, i) {
          img.style.cursor = 'zoom-in';
          img.addEventListener('click', function () { show(i); });
        });
        lb.querySelector('.bid-lightbox__close').addEventListener('click', hide);
        lb.querySelector('.bid-lightbox__nav--prev').addEventListener('click', function () { show(index - 1); });
        lb.querySelector('.bid-lightbox__nav--next').addEventListener('click', function () { show(index + 1); });
        lb.addEventListener('click', function (e) {
          if (e.target === lb) hide();
        });
        document.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'Escape') hide();
          if (e.key === 'ArrowLeft') show(index - 1);
          if (e.key === 'ArrowRight') show(index + 1);
        });
      });
    }
  };
})(Drupal, once);
